import { render, staticRenderFns } from "./InventoryReport.vue?vue&type=template&id=4182bb06&scoped=true"
import script from "./InventoryReport.vue?vue&type=script&lang=js"
export * from "./InventoryReport.vue?vue&type=script&lang=js"
import style0 from "./InventoryReport.vue?vue&type=style&index=0&id=4182bb06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4182bb06",
  null
  
)

export default component.exports